<template>
  <div
    class="container-fluid basket-pane pt-2 w-100"
    :class="{ 'h-100': !isCheckout }"
    ref="basket-pane"
  >
    <div v-if="!is_ready('basket')">
      <div class="col-12 text-center text-muted">Loading your basket...</div>
    </div>
    <div class="basket-items row" v-else-if="Object.keys(items).length > 0">
      <div class="col-12">
        <basket-item
          v-if="adding && !isProductAlreadyInBasket(adding)"
          :item="{}"
          frozen
          class="mb-2 pb-2"
        ></basket-item>
        <div v-for="(group_items, group_name) in groups" :key="group_name">
          <div class="basket-group-header row" v-if="grouped && group_items">
            {{ group_name }}
          </div>
          <basket-item
            v-for="(item, key) in group_items"
            :key="key"
            :item="item"
            :item-key="key"
            :ignore-reserved="!basket.allocated"
            :faded="highlight && highlight.toUpperCase() !== item.duty"
            :recently-updated="
              (key === basket._last_updated_item ||
                key === basket._last_added_item) &&
              !adding
            "
            :frozen="item ? item.product_id === adding : false"
            :id="'basket-item-id-' + key"
            class="mb-2 pb-2"
            @animationend="
              $store.commit('basket/set_last_updated', false);
              $store.commit('basket/set_last_added', false);
            "
          ></basket-item>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="col-12 text-center text-muted">
        There are no items in your basket.
      </div>
    </div>
  </div>
</template>


<script>
import { map, findKey } from "lodash-es";

import { mapGetters } from "vuex";

import BasketItem from "@/components/BasketItem";

export default {
  data() {
    return {};
  },
  props: {
    isCheckout: {
      type: Boolean,
      default: false,
    },
    scrollToProduct: {},
    grouped: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: [Boolean, String],
      default: false,
    },
  },
  watch: {
    last_updated_item(val) {
      if (!val) return;
      this.$nextTick(function () {
        this.scrollBasketPane(
          document.getElementById("basket-item-id-" + val).offsetTop
        );
      });
    },
    scrollToProduct(val) {
      this.scrollToProductId(val);
    },
  },
  mounted() {
    if (this.scrollToProduct) {
      this.scrollToProductId(this.scrollToProduct);
    }
  },
  components: {
    BasketItem,
  },
  provide: function () {
    return {
      scrollBasketPane: this.scrollBasketPane,
    };
  },
  computed: {
    adding() {
      return this.$store.state.basket._adding;
    },
    groups() {
      var grouped = {};
      var group_name = " ";

      for (var k in this.items) {
        switch (this.items[k].duty) {
          case "DP":
            group_name = "Duty Paid";
            break;
          case "IB":
            group_name = "In Bond";
            break;
          case "DPA":
            group_name = "Apply Duty Paid";
            break;
          case "IBA":
            group_name = "Apply In Bond";
            break;
          case "DPP":
            group_name = "Pre-Order Duty Paid";
            break;
          case "IBP":
            group_name = "Pre-Order In Bond";
            break;
        }

        if (!grouped[group_name]) {
          grouped[group_name] = {};
        }

        grouped[group_name][k] = this.items[k];
      }

      if (this.highlight && this.highlight.toUpperCase() === "IB") {
        return {
          "In Bond": grouped["In Bond"],
          "Duty Paid": grouped["Duty Paid"],
        };
      } else {
        return {
          "Duty Paid": grouped["Duty Paid"],
          "In Bond": grouped["In Bond"],
        };
      }
    },
    items() {
      return this.$store.state.basket.items;
    },
    basket() {
      return this.$store.state.basket;
    },
    last_updated_item() {
      return this.$store.state._last_updated_item;
    },
    ...mapGetters("readiness", ["is_ready"]),
  },
  methods: {
    scrollToProductId(product_id) {
      var key = findKey(this.items, (o) => {
        if (o.product_id === product_id) return true;
        return false;
      });

      if (key) {
        var $el = document.getElementById("basket-item-id-" + key);
        if ($el) {
          this.scrollBasketPane($el.offsetTop);
        }
      }
    },
    scrollBasketPane(y) {
      this.$nextTick(function () {
        this.$refs["basket-pane"].scrollTo(0, y);
      });
    },
    isProductAlreadyInBasket(product_id) {
      return map(this.items, "product_id").indexOf(product_id) !== -1;
    },
  },
};
</script>